import { Inject, Injectable } from '@angular/core';
import { Script, ScriptsSources, UrlRequiredParam } from '../../../configuration/Script';
import { isNullOrUndefined } from 'util';
import { DOCUMENT } from '@angular/common';

@Injectable()
export class ExternalScriptService {

  constructor(@Inject(DOCUMENT) private document) {
    // let scripts = travelConfigurationService.uiConfig.scripts;
    // scripts.forEach(script => {
    //   console.log(script.name);
    // })
  }

  public process(scripts: Script[]) {
    for (let i = 0; i < scripts.length; i++) {
      let script = scripts[i];
      let urlRequiredParams = script.config.urlRequiredParam;
      let shouldBeAdded: boolean = true;
      for (let j = 0; j < urlRequiredParams.length; j++) {
        if (!this.isAvailableInUrlParams(urlRequiredParams[j])) {
          shouldBeAdded = false
        }
      }
      if (shouldBeAdded) {
        this.addScript(script.config.scriptsSources)
      } else {
        console.log('Skip processing external script: ' + script.name);
      }
    }
  }

  private isAvailableInUrlParams(urlRequiredParam: UrlRequiredParam) {
    let urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has(urlRequiredParam.name)) {
      let param = urlParams.get(urlRequiredParam.name);
      if (!isNullOrUndefined(param)) {
        if (param === urlRequiredParam.value) {
          return true;
        }
      }
    }
    return false;
  }

  private addScript(scriptsSources: ScriptsSources) {
    for (let i = 0; i < scriptsSources.toHead.length; i++) {
      let script = scriptsSources.toHead[i];
      if (script[0] === '<') {
        this.document.getElementsByTagName('head')[0].insertAdjacentHTML('beforeend', script);
      } else {
        let element = this.document.createElement('script');
        element.type = 'text/javascript';
        element.innerHTML = script;
        this.document.getElementsByTagName('head')[0].appendChild(element);
      }
    }
    for (let i = 0; i < scriptsSources.toBody.length; i++) {
      let script = scriptsSources.toBody[i];
      if (script[0] === '<') {
        this.document.getElementsByTagName('body')[0].insertAdjacentHTML('beforeend', script);
      } else {
        let element = this.document.createElement('script');
        element.type = 'text/javascript';
        element.innerHTML = script;
        this.document.getElementsByTagName('body')[0].appendChild(element);
      }
    }
  }
}
